<template>
  <div class="page">
    <div style="background-color: #fff; font-size: 23px;padding: 20px 0 20px 15px;text-align: left;
    display: flex;align-items: center;">
      <div><img alt="公司理念" src="./../assets/1699605561234.jpg" style="height: 80px; margin: 0 auto;"></div>
      <div><span style="padding-left: 20px">广西诺加信息技术有限公司</span></div>
    </div>
    <el-carousel :interval="5000" arrow="always">
      <el-carousel-item class="carousel-item">
        <div class="carousel-item-txt">重构</div>
      </el-carousel-item>
      <el-carousel-item class="carousel-item">
        <div class="carousel-item-txt">协同</div>
      </el-carousel-item>
      <el-carousel-item class="carousel-item">
        <div class="carousel-item-txt">互生</div>
      </el-carousel-item>
    </el-carousel>

      <div class="rowBox">
        <div>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="title">公司概况</span>
            </div>
            <div>
              <p>
                    广西诺加信息技术有限公司,成立于2014年是一家专注基层医疗机构的医疗信息化研发、销售、服务为一体的高科技软件企业，亦是广西乡村振兴产业发展促进会副会长单位,
                为乡村振兴贡献高科技力量。

                公司团队技术全面、经险丰富，具有较强的为行业信息化提供整体解决方案、大数据治理、质目部署实施与本地化维保能力。
                公司团队为20个县级卫健系统，近400家医院提供了医疗信息化建设与维保服务，是广西县域医疗信自二休化(县乡村)建设的开创者。

                公司拥有整体解决医院升级的系统性产品。
                并有长期服务庞大客户群沉淀的本地化的服务能力,继续巩固广西基层医疗机构信息化建设首选服务商的地位。
              </p>
            </div>
          </el-card>
        </div>
        <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
          <img alt="公司理念" src="./../assets/1699604994013.png" style=" height: 400px; margin: 0 auto;">
        </div>
      </div>

    <el-card class="box-card" style="margin-top: 20px;width: 100%">
      <div slot="header" class="clearfix">
        <span class="title">公司产品</span>
      </div>
      <div style="gap: 10px;display: grid;grid-template-rows: 1fr;grid-template-columns: repeat(4, 1fr);">
        <div class="products">
          <div class="productsTitle">基础产品</div>
          <div>医院基础管理系统</div>
          <div>临床诊疗管理系统</div>
          <div>实验室管理系统</div>
          <div>影像图像传输与归档系统</div>
          <div>临床数据中心</div>
        </div>
        <div class="products">
          <div class="productsTitle">高级产品</div>
          <div>病历质控系统</div>
          <div>临床路径系统</div>
          <div>移动查房系统</div>
          <div>移动护理系统</div>
          <div>护理交互大屏系统</div>
          <div>临床合理用药系统</div>
          <div>临床智能知识库系统</div>
          <div>消毒供应室管理系统</div>
          <div>移动后勤系统</div>
          <div>体检管理系统</div>

        </div>
        <div class="products">
          <div class="productsTitle">便民产品</div>
          <div>缴费、药房排队叫号系统</div>
          <div>影像、图像排队叫号系统</div>
          <div>便民自助机</div>
          <div>诊间支付系统</div>
          <div>患者手机APP掌上医院</div>

        </div>
        <div class="products">
          <div class="productsTitle">区域产品</div>
          <div>区域电子病历系统</div>
          <div>区域卫生室信息系统</div>
          <div>区域近临床医疗知识库</div>
          <div>区域影像图像传输与归档信息系统</div>
          <div>区域患者便民服务平台</div>
        </div>
      </div>


    </el-card>


    <div style="margin-top: 20px;padding: 20px;height: 50px;border-top: 1px solid #e5e5e5">
      <el-link type="primary" href="https://beian.miit.gov.cn/">桂ICP备20001070号-1</el-link>
      <el-link type="primary">&nbsp;&nbsp;&nbsp;基层医疗服务商</el-link>
      <el-link type="primary">&nbsp;&nbsp;&nbsp;电话：0771-3396178</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page{
  margin-bottom: 10px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
h1{
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.box-card {
  width: 800px;
  height: 400px;
}
.title{
  font-size: 20px;
  font-weight: bold;
}
.rowBox{
  margin-top: 20px;
  display: flex;
  gap: 10px;
  height: 400px;
}

p{
  line-height: 2;
}
.productsTitle{
  background-color: rgba(6, 74, 143, 0.55);
  padding: 5px 25px 5px 25px;
  text-align: center;
  color: #fff;
}
.products > div{
  margin-bottom: 5px;
}
.carousel-item{
  text-align: center;
  font-weight: bold;
  font-size: 50px;
  margin: 0 auto;
}
.carousel-item-txt{
  height: 100%;display: flex;align-items: center;justify-content: center
}
</style>
